import { delay, get } from 'lodash';

import { store } from '../../redux';
import constants from '../../constants';
import { selectMe } from '../../redux/me/selectors';

export const ngRedirect = (
  route,
  { propertyData, userData = selectMe(store.getState()) },
) => {
  let newRoute = route;

  const finalUserData =
    userData !== undefined && userData !== null
      ? userData
      : selectMe(store.getState);
  const fianlPropertyData =
    propertyData || get(finalUserData, 'properties.0', {});
  if (fianlPropertyData.id) {
    newRoute = newRoute.replace(':pid', fianlPropertyData.id);
  }

  if (finalUserData) {
    newRoute = newRoute.replace(':uid', finalUserData.id);
  }

  delay(() => {
    window.location = `${constants.BASE_URL}${newRoute}`;
  }, 100);
};
